function initCartOverlay() {
    const notification = document.getElementById('cart-overlay');
    let timer = null;

    if (!notification) return;
    // jQuery is necessary for Woocommerce ... 
    window.jQuery(document.body).on('added_to_cart', function () {
        console.log("Produit ajouté au panier !");

        if (timer) clearTimeout(timer);

        notification.classList.add('is-active');

        setTimeout(() => {
            notification.classList.add('is-active');
        }, 50);

        timer = setTimeout(() => {
            notification.classList.remove('is-active');
        }, 3000);
    });
}